import React, { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux";
import ReactModal from "react-modal";
import { Card } from "rebass";

import { getModalType } from "../../../store/modules/modal/selectors";
import { closeModal } from "../../../store/modules/modal/actions";

import { MODAL_STYLE_SETTINGS } from "./settings";

import AddRecordModal from "../AddRecord/Modal";
import { CloseButton } from "../CloseButton";
import { ActionType } from "../Library/ContentMenu/types";
import { AddFolder } from "../../forms/AddFolder";
import { DeleteForm } from "../../forms/DeleteForm";
import { RenameForm } from "../../forms/RenameForm";
import { ShowFile } from "../ShowFile";

const modalStyles = {
  overlay: MODAL_STYLE_SETTINGS.overlay,
  content: MODAL_STYLE_SETTINGS.content,
};

const MODAL_TYPES: { [key: string]: any } = {
  "addFiles": AddRecordModal,
  "showFile": ShowFile,
  [ActionType.RENAME]: RenameForm,
  [ActionType.DELETE]: DeleteForm,
  [ActionType.ADD_FOLDER]: AddFolder,
};

export const Modal: React.FC = () => {
  const dispatch = useDispatch();
  const modalType = useSelector(getModalType);
  const dispatchCloseModal = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);
  const SpecifiedModal = modalType && MODAL_TYPES[modalType];

  return (
    <ReactModal
      isOpen={modalType !== undefined}
      onRequestClose={dispatchCloseModal}
      ariaHideApp={false}
      style={modalStyles}
    >
      {
        SpecifiedModal
        && (
          <Card
            borderRadius="5px"
            css="overflow: hidden;"
          >
            <SpecifiedModal dispatchCloseModal={dispatchCloseModal} />
          </Card>
        )
      }

      <CloseButton onClick={dispatchCloseModal} />
    </ReactModal>
  );
};
